var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"pad-bottom--xl pad-top--sm"},[_c(_vm.crmData.type,{tag:"component",attrs:{"crmData":_vm.crmData},on:{"deleteData":_vm.deleteCRM,"save":_vm.saveCrm,"close":_vm.closeWidget}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }